import React from "react"

import { css } from "@emotion/react"

import { PrimaryText } from "./primaryText.element"
import { TooltipElement } from "./tooltip.element"

export const FloatingLabelElement: React.FunctionComponent<
    IFloatingLabelElementProps
> = props => {
    return (
        <div
            className="flex items-center"
            css={[
                styles.container,
                props.isFloated
                    ? styles.floatedContainer
                    : props.inputHasPrefix
                      ? styles.notFloatedContainerPaddedLeft
                      : styles.notFloatedContainer,
                props.containerClassName,
            ]}
        >
            <PrimaryText
                typography={props.isFloated ? "caption" : "text"}
                css={[!props.isFloated ? styles.notFloatedText : undefined]}
                className={`
                    ${props.labelClassName}
                    ${!props.labelClassName ? "truncate" : ""}
                `}
            >
                {props.label}
                {props.withRequiredStar ? "*" : ""}
            </PrimaryText>

            {props.tooltip && props.isFloated ? (
                <TooltipElement className="ml-[4px]" text={props.tooltip} />
            ) : null}
        </div>
    )
}

const styles = {
    container: css({
        transition: "all 0.2s linear",
        position: "absolute",
        zIndex: 20,
    }),
    floatedContainer: css({
        left: 0,
        top: -22,
    }),
    notFloatedContainer: css({
        pointerEvents: "none",
        left: 12,
        top: 12,
    }),
    notFloatedContainerPaddedLeft: css({
        pointerEvents: "none",
        left: 37,
        top: 12,
    }),
    notFloatedText: css({
        opacity: 0.5,
    }),
}

interface IFloatingLabelElementProps {
    containerClassName?: string
    labelClassName?: string
    isFloated?: boolean
    label: string
    withRequiredStar?: boolean
    tooltip?: string
    inputHasPrefix?: boolean
}
